import { useEffect, useRef } from "react";

export default function TurnstileWidget({ sitekey, onVerify }) {
  const ref = useRef();

  useEffect(() => {
    function renderWidget() {
      if (window.turnstile && ref.current) {
        // Entferne evtl. vorhandene Turnstile-Widgets im Container
        while (ref.current.firstChild) {
          ref.current.removeChild(ref.current.firstChild);
        }
        window.turnstile.render(ref.current, {
          sitekey,
          callback: onVerify,
        });
      }
    }
    if (!window.turnstile) {
      if (!document.getElementById("cf-turnstile-script")) {
        const script = document.createElement("script");
        script.id = "cf-turnstile-script";
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
        script.async = true;
        document.body.appendChild(script);
        script.onload = renderWidget;
      } else {
        document.getElementById("cf-turnstile-script").addEventListener("load", renderWidget);
      }
    } else {
      renderWidget();
    }
    return () => {
      // Widget entfernen
      if (ref.current) {
        while (ref.current.firstChild) {
          ref.current.removeChild(ref.current.firstChild);
        }
      }
    };
  }, [sitekey, onVerify]);

  return <div ref={ref} className="cf-turnstile" style={{marginTop:16, marginBottom:8}}></div>;
}
